
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class AutoCompleteViewer extends Vue {
  private inputId: string = 'search-gmap'
  setPlace (place: any) {
    this.$emit('place_changed', place)
  }
}
